import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  GetChildGenderType,
  SystemAdminSpecificChild,
  UpdateSystemAdminChild
} from "../../Repository/Api";
import { errorMsg, successMsg } from "../Toastify";

const SystemadminEmployeechildspecific = () => {
  const { first_name, last_name, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const { id } = useParams();
  const navigate = useNavigate();

  const [specificChild, setSpecificChild] = useState({});
  const [genderChildtype, setGenderChildtype] = useState([]);

  useEffect(() => {
    getSpecificChild();
    getChildGenderType();
  },[]);

  const getSpecificChild = async () => {
    const response = await SystemAdminSpecificChild(id, token);
    if (response && response.statusCode === 200) {
      setSpecificChild(response.data);
    } else {
      errorMsg(response.message);
    }
  };
  const getChildGenderType = async () => {
    const response = await GetChildGenderType(token);
    if (response && response.statusCode === 200) {
      setGenderChildtype(response?.data?.master_data);
    } else {
      errorMsg(response.message);
    }
  };

  const setData = (e, key) => {
    setSpecificChild({ ...specificChild, [key]: e });
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    const Payload = {
      id: id,
      name: specificChild.name,
      gender_id: specificChild.gender_id,
      dob: specificChild.dob,
    };

    const response = await UpdateSystemAdminChild(Payload, token);
    if (response && response.statusCode === 200) {
      successMsg(response.message);
      setSpecificChild({});
      e.target.reset();
      window.location.reload();
    } else {
      errorMsg(response.message);
    }
  };

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-5">
            <div className="row">
              <div className="col-lg-6">
                <h6 className="headertext">
                  {first_name} {last_name}
                </h6>
              </div>
            </div>
          </div>
        </section>
        <section className="my-5">
          <div className="row">
            <div className="">
              <div className="graphbox">
                <h6 className="labeltitle">
                  <span
                    className="arrowicon"
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    ← &nbsp;
                  </span>
                  Child Details
                </h6>
                <form onSubmit={(e) => handleUpdate(e)}>
                  <div className="row">
                    <div className="col-lg-4">
                      <label className="labeltext">Name of the Child</label>
                      <input
                        type="text"
                        className="fieldinput"
                        value={specificChild?.name}
                        onChange={(e) => {
                          setData(e.target.value, "name");
                        }}
                      />
                    </div>
                    <div className="col-lg-4">
                      <label className="labeltext"> Gender</label>
                      <select
                        className="fieldinput"
                        value={specificChild.gender_id}
                        onChange={(e) => {
                          setData(e.target.value, "gender_id");
                        }}
                      >
                        <option value="">Select Gender Type</option>
                        {genderChildtype?.map((e, index) => (
                          <option key={index} value={e.id}>
                            {e.master_value}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col-lg-4">
                      <label className="labeltext">Date of Birth:</label>
                      <input
                        type="date"
                        className="fieldinput"
                        placeholder=""
                        value={moment(specificChild.dob).format("yyyy-MM-DD")}
                        onChange={(e) => {
                          setData(e.target.value, "dob");
                        }}
                      />
                    </div>
                  </div>
                  <div className="centertext my-5">
                    <button className="requestbtn">Update</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SystemadminEmployeechildspecific;
